/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';

export interface DocumentsAPIResponse {
    Id: string;
    Name: string;
    Description: string;
    CreatedTime: string;
    UpdatedTime: string;
}
export interface ApiResponse {
    statusCode: number;
    data: any;
    message?: string;
}

export const getDocumentsList = async (contractId: string, showLoader: boolean = true): Promise<ApiResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: `${api_urls.GetDocumentsList}/${contractId}`,
            showLoader,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error fetching contracts:', error);
        throw error;
    }
};

export const getDocumentPreview = async (documentId: string, showLoader: boolean = true): Promise<ApiResponse> => {
    try {
        console.log('🔗 API Call: Fetching document preview for ID:', documentId);

        const axiosResponse: any = await api_service.get({
            endPoint: `${api_urls.GetDocumentPreview}/${documentId}`,
            showLoader,
        });

        // Axios wraps the response in .data property
        const apiResponse = axiosResponse?.data || axiosResponse;

        console.log('✓ API Response received');
        console.log('  Status Code:', apiResponse?.statusCode);
        console.log('  Data type:', typeof apiResponse?.data);
        console.log('  Data length:', apiResponse?.data?.length || 'N/A');
        console.log('  Message:', apiResponse?.message);

        // ✅ CORE FIX: Ensure we always return the base64 string in the data property
        if (apiResponse?.statusCode === 200 && apiResponse?.data) {
            // The base64 is already in apiResponse.data, return it directly
            console.log('✓ Returning successful response with base64 data');
            return {
                statusCode: 200,
                data: apiResponse.data, // This should be the base64 string
                message: apiResponse.message,
            };
        }

        // Fallback for other response structures
        if (typeof apiResponse === 'string' && apiResponse.length > 0) {
            console.log('✓ Returning direct base64 string response');
            return { statusCode: 200, data: apiResponse };
        }

        // If it has statusCode but not 200
        if (apiResponse?.statusCode) {
            console.warn('⚠️ Response has non-200 status code:', apiResponse.statusCode);
            return apiResponse;
        }

        // Unexpected structure
        console.warn('⚠️ Unexpected API response structure');
        return { statusCode: 500, data: null, message: 'Unexpected response structure' };
    } catch (error: any) {
        console.error('❌ Error fetching document preview:', error);
        throw error;
    }
};

export const uploadDocument = async (
    contractId: string,
    file: File,
    showLoader: boolean = true,
): Promise<ApiResponse> => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response: any = await api_service.post({
            endPoint: `${api_urls.UploadDocument}/${contractId}`,
            payLoad: formData,
            headerType: api_service.ContentHeaders.FormData,
            showLoader,
        });

        const responseData = response?.data || response;

        if (responseData.statusCode && responseData.statusCode === 200) {
            return responseData;
        } else if (responseData.statusCode) {
            return responseData;
        }
        return { statusCode: 200, data: responseData };
    } catch (error: any) {
        console.error('Error uploading document:', error);
        throw error;
    }
};

export const getAllEnabledFileExtensions = async (): Promise<ApiResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: `${api_urls.GetAllEnabledFileExtensions}`,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error fetching all enabled file extensions:', error);
        throw error;
    }
};
